import React, { ChangeEvent } from "react";
import InputSelect from "../../../components/InputSelect";
import { StyledActionsFilterContainer } from "../../../styles/pages/AdministratorTach/FilterTachStyles";
import SelectOption from "../../../model/SelectOption";
import { getOptionsStatusSubprocess } from "../../../model/Enums/StatusSubprocessEnum";
import { useFilterData } from "../../../context/TachContext/FilterDataContext";

const initialFilterOption = { value: "", label: "Selecione o Status Workflow" };

const SelectStatusTach = () => {
    const { filterPage, setFilterPage } = useFilterData();
    const [selectedStatus, setSelectedStatus] =
        React.useState<typeof initialFilterOption>(initialFilterOption);

    const filters = getOptionsStatusSubprocess().filter(
        (row) => row.value !== "WAITING_APPROVAL"
    );

    const options: SelectOption[] = [initialFilterOption, ...filters];

    const handleChange = (event: ChangeEvent<{ value: unknown }>): void => {
        setSelectedStatus(event.target.value as typeof initialFilterOption);
        setFilterPage({
            ...filterPage,
            status: event.target.value as string,
        });
    };

    return (
        <StyledActionsFilterContainer>
            <InputSelect
                handleSelectChange={(e) => handleChange(e)}
                optionsSelect={options}
                value={selectedStatus.value}
                style={{ margin: "15px 0" }}
                styleFormGroup={{ width: "100%" }}
            />
        </StyledActionsFilterContainer>
    );
};

export default SelectStatusTach;
